// login url
const RESET_PASSWORD_CONFIRM_URL = process.env.VUE_APP_RESET_PASSWORD_CONFIRM;

export default {
  name: "PasswordResetConfirm",
  data() {
    return ({
      password: "",
      password_input_type: 'password',
      confirmPassword: "",
      error_message: "",
      success_message: "",
      is_loading: false,
    });
  },
  methods: {
    toggle_change_password_type() {
      this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password';
    },
    async submitNewPassword() {
        this.error_message = "";
        this.success_message = "";

        if (this.password !== this.confirmPassword) {
        this.error_message = "Passwords do not match.";
        return;
        }

        if (this.password.length < 8) {
        this.error_message = "Password must be at least 8 characters.";
        return;
        }

        this.is_loading = true;
        // Make login request
        const response = await fetch(RESET_PASSWORD_CONFIRM_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            new_password: this.password,
            token: this.$route.query.token
          })
        });
        console.log('Password reset response:', response);
        if (response.ok) {
          this.success_message = "Password has been successfully reset.";
          // Redirect to success sent email page after
        this.$router.push('/password_reset_complete');
        } else {
          const errorData = response.json();
          this.error_message = errorData.detail || "An error occurred while resetting the password.";
        }

        this.is_loading = false;
    }
    }

};
